export default __webpack_public_path__ + "static/mar-call-center-telecome-94ed5cae6c84ebf737cb10b65d1a1606.png";